/* 
Pantalla de login enrutado para registrar, contraseña olvidada, reenviar mail de confirmación
 */

import React from "react";
import clsx from "clsx";

//REDUX
import { useDispatch } from "react-redux";
import {
  loginAction,
  restorePasswordAction,
  resendConfirmationMailAction
} from "../../redux/actions/userActions";

//COMPONENTS
import AlertDialog from "../../components/AlertDialog";
import { CookieConsent } from 'ilusiona-react-components';

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
// eslint-disable-next-line
// import Tooltip from "@material-ui/core/Tooltip";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Link } from "@material-ui/core";
const useStyles = makeStyles({
  "@global": {
    body: {
      backgroundColor: "#363636",
    },
  },
  root: {
    marginTop: "30px",
    display: "flex"
  },
  boxform: {
    backgroundColor: "#FFFFFF",
    paddingTop: "20px",
    paddingBottom: "20px",
    marginTop: "5px",
    marginBottom: "25px",
    border: "1px solid #30363db3",
    borderRadius: "0.1875rem",
  },
  border: {
    boxShadow: "0px 0px 3px 1px #363636",
    paddingTop: "20px",
    paddingBottom: "20px",
    marginTop: "5px",
    marginBottom: "25px"
  },
  primary: {
    color: "white",
    marginTop: "10px"
  },
  secondari: {
    color: "white",
    textTransform: "none"
  },
  link: {
    color: "#DF7D44"
  },
  buttonlink: {
    color: "#DF7D44",
    marginTop: "10px"
  }
});
//#endregion

function Login({ history, mail }) {
  const handleAcceptAllCookies = (settings) => {
    console.log('Usuario aceptó todas las cookies:', settings);
  };
  
  const handleAcceptSelectedCookies = (settings) => {
    console.log('Usuario configuró cookies:', settings);
  };
  const classes = useStyles();
  const disabledBtn = false;
  //Move camera top
  /* const comp = document.querySelector("#root").offsetTop - 100;
  window.scroll({ behavior: "smooth", top: comp });
 */
  //#region Values
  const [values, setValues] = React.useState({
    email: mail !== "home" ? mail : "",
    password: "",
    /* email: "test@test.com",
    password: "Test15", */
    showPassword: false,
    errorMessage: "",
    typeMessage: "",
    showRestorePassword: false,
    showDialog: false,
    dialogMessage: "",
    dialogLink: false
  });
  //#endregion

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const login = (email, password) => dispatch(loginAction(email, password));
  const restorePassword = email => dispatch(restorePasswordAction(email));
  const resendConfirmationMail = mail =>
    dispatch(resendConfirmationMailAction(mail));
  //#endregion

  //#region HandleChange
  const handleChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  //#endregion

  //#region OnClicks
  const onClickLogin = e => {
    e.preventDefault();

    if (
      values.email.trim().length === 0 ||
      values.password.trim().length === 0
    ) {
      setValues({ ...values, errorMessage: "required_field" });
      return;
    }

    // Las cookies necesarias se procesan automáticamente
    // Las cookies opcionales se procesan según la selección del usuario

    login(values.email, values.password)
      .then(() => {
        history.push("/home");
      })
      .catch(error => {
        if (error) {
          switch (error.status) {
            case 404:
              let copyValues = Object.assign({}, values);
              copyValues.errorMessage = "login_error_credentials";
              copyValues.typeMessage = "";
              setValues(copyValues);
              break;
            case 409:
              if (error.data === "ChangePassword") {
                let copyValues = Object.assign({}, values);
                copyValues.showDialog = true;
                copyValues.dialogMessage = "restore_sent";
                setValues(copyValues);
              } else if (error.data === "Bloqueado") {
                let copyValues = Object.assign({}, values);
                copyValues.showDialog = true;
                copyValues.dialogLink = true;
                setValues(copyValues);
              } else {
                let copyValues = Object.assign({}, values);
                copyValues.errorMessage = "login_error_email_not_confirmed";
                copyValues.typeMessage = "link";
                setValues(copyValues);
              }
              break;
            default:
              break;
          }
        } else {
          setValues({
            ...values,
            errorMessage: "login_error_server"
          });
        }
      });
  };

  const onClickRegister = () => {
    history.push("/registrar");
  };

  const onClickShowRestorePassword = () => {
    const copyValues = Object.assign({}, values);
    copyValues.showRestorePassword = !copyValues.showRestorePassword;
    copyValues.errorMessage = "";
    setValues(copyValues);
  };

  const onClickRestorePassword = () => {
    if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(values.email)) {
      setValues({
        ...values,
        errorMessage: "login_email_invalid"
      });
      return;
    }

    restorePassword(values.email)
      .then(v => {
        let copyValues = Object.assign({}, values);
        copyValues.errorMessage = "";
        copyValues.showDialog = true;
        copyValues.dialogMessage = "restore_sent";
        copyValues.showRestorePassword = !copyValues.showRestorePassword;
        setValues(copyValues);
      })
      .catch(error => {
        if (error) {
          switch (error.status) {
            case 404:
              let copyValues = Object.assign({}, values);
              copyValues.errorMessage = "login_email_invalid";
              copyValues.typeMessage = "";
              setValues(copyValues);
              break;
            case 409:
              if (error.data === "Bloqueado") {
                let copyValues = Object.assign({}, values);
                copyValues.showDialog = true;
                copyValues.dialogLink = true;
                setValues(copyValues);
              }
              break;
            default:
              break;
          }
        } else {
          setValues({
            ...values,
            errorMessage: "login_error_server"
          });
        }
      });
  };

  const onClickResendConfirmation = () => {
    resendConfirmationMail(values.email).then(() => {
      let copyValues = Object.assign({}, values);
      copyValues.showDialog = true;
      copyValues.dialogLink = false;
      copyValues.dialogMessage = "resend_sent";
      setValues(copyValues);
    }).catch(() => {
      let copyValues = Object.assign({}, values);
      copyValues.showDialog = true;
      copyValues.dialogLink = false;
      copyValues.dialogMessage = "login_error_server";
      setValues(copyValues);
    });

  }
  //#endregion

  return (
    <div className={classes.root}>
      <AlertDialog
        show={values.showDialog}
        setShow={v => setValues({ ...values, showDialog: v })}
      >
        <DialogContentText id="alert-dialog-slide-description" data-lang={values.dialogMessage}>
          {values.dialogLink ?
            <React.Fragment>
              <p data-lang-html="login_dialog_blocked">
                Consulta con tu centro tienes la tarjeta bloqueada o envia un mail a{" "}
                <a href="mailto:ilusiona.club@ilusiona.com" style={{ color: "#923289" }}>
                  ilusiona.club@ilusiona.com
                    </a>.
              </p>
            </React.Fragment>
            : values.dialogMessage}
        </DialogContentText>
      </AlertDialog>
      <Fade in={true}>
        <Grid 
          container 
          //spacing={2} 
          justify="center" 
          alignItems="center">
          <Grid item style={{ padding: "8px" }} >
            <Box textAlign="center">
              <img
                alt="Tarjeta"
                height="80"
                src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
                title="Bienvenida"
              />
            </Box>
          </Grid>
          <Grid item xs={10} style={{ marginTop: "15px" }}>
            <Box textAlign="center">
              <Typography color="primary" variant="h4" data-lang="login_title">
                Tarjeta Fidelización de ILUSIONA CLUB
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={10}>
            <Box textAlign="center">
              <Typography variant="h5" style={{ color: "white" }} data-lang="login_subtitle">
                ¡Consigue ya tu tarjeta, totalmente gratis!
              </Typography>
            </Box>
          </Grid>

          {/* Seccion IMAGEN TARJETA */}
          <Grid item xs={10} md={10} lg={10} style={{ padding: "8px" }}>
            <Box textAlign="center">
              <img
                alt="Tarjeta"
                height="140"
                src={`${process.env.PUBLIC_URL}/assets/img/tarjeta_V2.png`}
                title="Tarjeta"
              />
            </Box>
          </Grid>

          <Grid container justify="center" alignItems="center">
            {/* Seccion LOGIN FORM */}
            <Fade in={!values.showRestorePassword}>
              <Grid
                container
                item
                xs={10}
                md={5}
                lg={3}
                spacing={2}
                justify="center"
                alignItems="center"
                className={classes.boxform}
                style={{
                  ...(!values.showRestorePassword ? {} : { display: "none" })
                }}
              >
                {/* <Tooltip title="Temporalmente deshabilitado. COVID-19"> */}
                <Grid item xs={10}>
                  <form className={classes.form} noValidate>
                    {values.errorMessage.length > 0 ? (
                      <Grid item xs={12}>
                      <div className="alert alert-danger" role="alert" data-lang={values.errorMessage}>
                        {values.errorMessage}{" "}
                        {values.typeMessage === "link" ? (
                          <a
                            href="#0"
                            onClick={onClickResendConfirmation}
                            data-lang="resend_confirmation"
                          >
                            Reenviar
                          </a>
                        ) : null}
                      </div>
                      </Grid>
                    ) : null}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="txt_email"
                      label={<span data-lang="login_email_label">Email</span>}
                      name="email"
                      autoComplete="email"
                      value={values.email}
                      onChange={handleChange("email")}
                    />
                    <FormControl
                      className={clsx(classes.margin, classes.textField)}
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        <span data-lang="login_password_label">Contraseña</span>
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={values.showPassword ? "text" : "password"}
                        value={values.password}
                        autoComplete="current-password"
                        onChange={handleChange("password")}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              data-lang-attr="aria-label"
                              data-lang-aria-label="profile_toggle_password"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                  <VisibilityOff />
                                )}
                            </IconButton>
                          </InputAdornment>
                        }
                        labelWidth={90}
                      />
                    </FormControl>

                    <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                      <Link
                        disabled={disabledBtn}
                        onClick={onClickShowRestorePassword}
                        //variant="text"
                        fullWidth
                        //className={classes.buttonlink}
                        style={{ color: "#DF7D44", cursor: "pointer" }}
                        data-lang="login_forgot"
                      >
                        ¿Olvidaste tu contraseña?
                      </Link>
                    </div>

                    <Button
                      disabled={disabledBtn}
                      onClick={onClickLogin}
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      className={classes.primary}
                      data-lang="login_button"
                    >
                      Entrar
                    </Button>
                  </form>
                </Grid>
                {/* </Tooltip> */}
                {/*<Tooltip title="Temporalmente deshabilitado. COVID-19">*/}
                <Grid item xs={10}>
                  <Button
                    disabled={disabledBtn}
                    variant="contained"
                    color="secondary"
                    fullWidth
                    className={classes.secondary}
                    onClick={onClickRegister}
                    data-lang="login_register_link"
                  >
                    Si NO eres socio
                    <span style={{ display: "block" }}> ÚNETE AL CLUB</span>
                  </Button>
                </Grid>
                {/* </Tooltip> */}
                {/*<Tooltip title="Temporalmente deshabilitado. COVID-19">*/}
              </Grid>
            </Fade>

            {/* Seccion RECUPERAR CONTRASEÑA */}
            <Fade in={values.showRestorePassword}>
              <Grid
                container
                item
                xs={10}
                md={5}
                lg={3}
                spacing={2}
                justify="center"
                alignItems="center"
                className={classes.boxform}
                style={{
                  ...(values.showRestorePassword ? {} : { display: "none" })
                }}
              >
                <Grid item xs={10}>
                  <Box textAlign="center">
                    <Typography color="secondary" variant="h5" data-lang="restore_title">
                      Recuperar contraseña
                    </Typography>
                  </Box>
                  {values.errorMessage.length > 0 ? (
                    <Grid item xs={12}>
                      <div className="alert alert-danger mt-3" role="alert" data-lang={values.errorMessage}>
                        {values.errorMessage}
                      </div>
                    </Grid>
                  ) : null}
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="txt_email_pass"
                    label={<span data-lang="login_email_label">Email</span>}
                    name="email"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleChange("email")}
                    autoFocus
                  />
                  <Button
                    onClick={onClickRestorePassword}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.primary}
                    data-lang="restore_send"
                  >
                    Recuperar
                  </Button>
                  <Button
                    onClick={onClickShowRestorePassword}
                    variant="contained"
                    color="secondary"
                    fullWidth
                    className={classes.primary}
                    data-lang="back"
                  >
                    Atrás
                  </Button>
                </Grid>
              </Grid>
            </Fade>
          </Grid>

          {/* Seccion TIENES DUDA */}
          <Grid item  style={{ color: "white" }}>
            <Box textAlign="center">
              <p data-lang="login_age_restriction">*Tarjeta de Fidelización únicamente para mayores de 18 años</p>
            </Box>
            <Box textAlign="center">
              <p style={{ fontSize: "0.8rem" }} data-lang-html="login_doubt">
                ¿Tienes alguna duda?
                <a
                  href="/frequent-question"
                  style={{ color: "#DF7D44", display: "block" }}
                  target="_blank"
                >
                  ¡Pincha aquí!
                </a>
              </p>
            </Box>
          </Grid>
        </Grid>
      </Fade>
      <CookieConsent 
        onAcceptAll={handleAcceptAllCookies}
        onAcceptSelected={handleAcceptSelectedCookies}
        autoShow={true}
      />
    </div >
  );
}

export default Login;
